import { render, staticRenderFns } from "./Game_alip_elimination.vue?vue&type=template&id=7226d3f2&style=true"
import script from "./Game_alip_elimination.vue?vue&type=script&lang=js"
export * from "./Game_alip_elimination.vue?vue&type=script&lang=js"
import style0 from "./Game_alip_elimination.vue?vue&type=style&index=0&id=7226d3f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports